"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default(fn, ms) {
  if (!ms) {
    return fn;
  }
  var last = 0;
  var timeout = null;
  return function () {
    var _arguments = arguments;
    var now = Date.now();
    if (now - last > ms) {
      fn.apply(null, arguments);
      last = now;
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(null, _arguments);
        last = Date.now();
      }, Math.max(0, ms - now + last));
    }
  };
}